import {useState } from "react";
import { toast} from 'react-hot-toast';
import { find, includes} from "lodash";
import {
  HiDotsVertical,
  HiOutlinePencil,
  HiOutlineTrash,
} from "react-icons/hi";
import {
  useUsersAdminAction,
} from "../../../services/actions/users-admin.actions";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  crudUsersAdminAtom,
  usersAdminAtom,
} from "../../../services/atoms/users-admin.atom";
import LocalTable from "../../../components/table-local";
import EditUserAdminModal from "./components/edit-modal";
import ConfirmDialog from "../../../components/confirm-dialog/confirm-dialog";

const options = [
    { id: 'opt-1', title: 'Editar Usuario', action: 'edit', icon: HiOutlinePencil },
    { id: 'opt-2', title: 'Eliminar Usuario', action: 'remove', icon: HiOutlineTrash },
  ];

const getAttributes = (Attributes, key, additionalkey = '') => {
    let row = find(Attributes, (e) => e.Name === key);
    if (additionalkey) {
      let additionalRow = find(Attributes, (e) => e.Name === additionalkey);
      return <div>{`${row?.Value || ''} ${additionalRow?.Value || ''}`}</div>;
    }
    if(key==='custom:admin'){
     let rowRol = find(Attributes, (e) => e.Name === key);
     return <div>{rowRol?.Value === 'true' ? 'Administrador Empresa' : 'Analista'}</div>
    }
    return <div>{row?.Value || ''}</div>
  }

const columns = [
  {
    Header: "Nombre Completo",
    accessor: ({ Attributes }) =>
      getAttributes(Attributes, "name", "family_name"),
    disableSortBy: true,
  },
  {
    Header: "Correo",
    accessor: ({ Attributes }) => getAttributes(Attributes, "email"),
    disableSortBy: true,
  },
  {
    Header: "Rol",
    accessor: ({ Attributes }) => getAttributes(Attributes, "custom:admin"),
    disableSortBy: true,
  },
  { Header: 'Acciones', accessor: '', type: 'actions', disableSortBy: true },
];

const UsersAdmin = (props) => {
  const {clientName} = props;
  const { usersAdminsList, deleteUsersAdmin} = useUsersAdminAction();
  const [usersAdmin, setUsersAdmin] = useRecoilState(usersAdminAtom);
  const usersAdminResolver = useRecoilValue(crudUsersAdminAtom);
  const [open, setOpen] = useState({ edit: false, create: false });
  const [selectedUser, setUserSelected] = useState(null);
  // Usuario que se está por eliminar (null = diálogo cerrado).
  const [pendingDelete, setPendingDelete] = useState(null);

  const handleOpenModal = (key) =>
    setOpen((modal) => ({ ...modal, [key]: !modal[key] }));

  const handleOptionAction = (action, row) => {
    if (action === "remove") {
      handleDeleteAdminUsers(row);
    }
    if (action === "edit") {
      setUserSelected(row);
      handleOpenModal("edit");
    }
  };

  const handleDeleteAdminUsers = (row) => setPendingDelete(row);

  // Mismo flujo de antes: si falla, se avisa y el diálogo queda abierto para reintentar.
  const handleConfirmDelete = async () => {
    const row = pendingDelete;
    if (!row) return;
    let username = find(row?.Attributes || [], (e) => e?.Name === 'email');
    await deleteUsersAdmin(username?.Value || '', (res) => {
      if (includes(res?.message, 'Request failed with status')) {
        toast.error('El usuario no se ha podido eliminar', {duration:4000});
      } else {
        toast.success('Usuario eliminado exitosamente', {duration:4000});
        usersAdminsList(clientName);
        setPendingDelete(null);
      }
    });
  };

  const actions = [{ icon: HiDotsVertical, dropdown: true }];

  return (
    <div>
      {open.edit && (
        <EditUserAdminModal
        open={open.edit}
        toggle={()=>handleOpenModal('edit')}
        selectedUser={selectedUser}
        clientName={clientName}
        />
      )}
      <ConfirmDialog
        open={Boolean(pendingDelete)}
        title="¿Eliminar este usuario?"
        description={`${find(pendingDelete?.Attributes || [], (e) => e?.Name === 'email')?.Value || 'El usuario'} ya no podrá entrar a GrowMe.`}
        confirmLabel="Eliminar"
        onConfirm={handleConfirmDelete}
        onCancel={() => setPendingDelete(null)}
      />
      <LocalTable
        className="qs-table-header-light"
        columns={columns}
        actions={actions}
        options={options}
        handleOptionAction={handleOptionAction}
        data={usersAdmin?.payload || []}
        loading={usersAdmin.loading || usersAdminResolver.loading}
      />
    </div>
  );
};

export default UsersAdmin;
